// Module
var code = "<h2 id=\"postpone-payments\">Postpone Payments</h2> <p>If you cannot make any payments, consider postponing them with a deferment or forbearance, which may be the right choice to prevent your loan from entering default. </p> ";
// Exports
export default code;